(function () {
  function syncColorImage() {
    var productFormEl = document.querySelector('product-form');
    var form = (productFormEl && productFormEl.querySelector('form'))
      || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var imgUrls = [];
    var checked = document.querySelectorAll('.color-radio:checked');
    for (var i = 0; i < checked.length; i++) {
      var url = checked[i].dataset.imgUrl;
      if (url && imgUrls.indexOf(url) === -1) {
        imgUrls.push(url);
      }
    }

    var inputName = 'properties[_color_image]';
    var inp = form.querySelector('input[name="' + inputName + '"]');

    if (imgUrls.length > 0) {
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = inputName;
        form.appendChild(inp);
      }
      inp.value = imgUrls.join('|');
    } else if (inp) {
      inp.remove();
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('color-radio')) {
      syncColorImage();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncColorImage);
  } else {
    syncColorImage();
  }
})();
